// @ts-nocheck
/**
 * ViewModeToggle - 切换 PDF 视图和 Canvas 视图
 */
import React from 'react';
import './ViewModeToggle.css';

type ViewMode = 'pdf' | 'canvas';

interface ViewModeToggleProps {
  viewMode: ViewMode;
  onViewModeChange: (mode: ViewMode) => void;
  disabled?: boolean;
}

const ViewModeToggle: React.FC<ViewModeToggleProps> = ({ viewMode, onViewModeChange, disabled = false }) => {
  return (
    <div className="view-mode-toggle">
      <button
        className={`view-toggle-btn ${viewMode === 'pdf' ? 'active' : ''}`}
        onClick={() => onViewModeChange('pdf')}
        disabled={disabled}
        title="PDF 阅读视图"
      >
        📄 PDF 视图
      </button>
      <button
        className={`view-toggle-btn ${viewMode === 'canvas' ? 'active' : ''}`}
        onClick={() => onViewModeChange('canvas')}
        disabled={disabled}
        title="Canvas 空间视图（AFFiNE风格）"
      >
        🎨 Canvas 视图
      </button>
    </div>
  );
};

export default ViewModeToggle;
